import request, { METHODS } from "src/utils/api-base";

const customerApis = {
  // Create or get existing
  createCustomer: (payload: any) => {
    return request({
      route: "/app/customers/create",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },

  // List customers by tenant
  getCustomersList: (params: {
    search?: string;
    page?: number;
    limit?: number;
  }) => {
    return request({
      route: "/app/customers/list",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  // Get single customer
  getCustomerById: (id: string) => {
    return request({
      route: `/app/customers/${id}`,
      method: METHODS.GET,
      auth: true,
    });
  },

  updateCustomer: (id: string, payload: any) => {
    return request({
      route: `/app/customers/${id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },

  deleteCustomer: (id: string) => {
    return request({
      route: `/app/customers/${id}`,
      method: METHODS.DELETE,
      auth: true,
    });
  },

  // Bulk-create customers from parsed spreadsheet rows
  bulkImport: (rows: Array<Record<string, any>>) => {
    return request({
      route: "/app/customers/bulk-import",
      method: METHODS.POST,
      payload: { rows },
      auth: true,
    });
  },
};

export default customerApis;
